// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"114":"ROUTE-demo","121":"ROUTE-dataAssetInfoH5","141":"ROUTE-dataAsset2InfoH5"}[chunkId] || chunkId) + "." + chunkId + "." + __webpack_require__.h().slice(0, 7) + ".css";
};